import { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import api, { apiError, fileUrl } from "@/lib/api";

export default function ImageUpload({ value, onChange, label = "Upload image", testId, isPrivate = false }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      if (isPrivate) fd.append("private", "true");
      const res = await api.post("/admin/uploads", fd);
      onChange(res.data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(apiError(err, "Upload failed"));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {value ? (
        <div className="relative inline-block">
          <img src={fileUrl(value)} alt="Uploaded" className="h-24 w-32 rounded-md border border-border object-cover" />
          <button
            type="button"
            aria-label="Remove image"
            data-testid={`${testId}-remove`}
            onClick={() => onChange("")}
            className="absolute -right-2 -top-2 rounded-full bg-destructive p-1 text-destructive-foreground shadow"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      ) : (
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
          data-testid={testId}
        >
          {uploading ? "Uploading…" : label}
        </Button>
      )}
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={handleFile} />
    </div>
  );
}
